import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import OrdersCustomFilterViewContainer from '../../components/filterview-list/filterview/orders/custom-filterview-container';
import OrdersDefaultFilterViewContainer from '../../components/filterview-list/filterview/orders/default-filterview-container';
import OrdersFilterViewContainer from '../../components/filterview-list/filterview/orders/saved-filterview-container';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/orders/filtering/orders.filtering.actions';

import FilterViewList from './index';
import { useSelectedOrdersViewId } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

const savedViewsForStatusSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, currentGridViewId) => currentGridViewId,
  (savedFilterViews, currentGridViewId) => savedFilterViews.filter((view) => view.gridViewId === currentGridViewId),
);

const viewsToRenderSelector = createSelector(
  (defaultFilterView) => defaultFilterView,
  (_, savedFilterViews, currentGridViewId) => savedViewsForStatusSelector(savedFilterViews, currentGridViewId),
  (_, __, ___, customFilterView) => customFilterView,
  (defaultFilterView, savedViewsForStatus, customFilterView) => {
    const viewsToRender = [defaultFilterView, ...savedViewsForStatus];
    if (customFilterView) {
      viewsToRender.push(customFilterView);
    }
    return viewsToRender;
  },
);

const OrdersFilterviewListContainerInnerComponent = () => {
  const dispatch = useDispatch();
  const currentGridViewId = useSelectedOrdersViewId();
  const savedFilterViews = useSelector(Global.selectOrdersFilteringSavedFilterViews);
  const defaultFilterView = useSelector(Global.selectOrdersFilteringDefaultFilterView);
  const customFilterView = useSelector(Global.selectOrdersFilteringCustomFilterView);
  const activeFilterView = useSelector(Global.selectOrdersFilteringActiveFilterView);
  const filterViews = viewsToRenderSelector(defaultFilterView, savedFilterViews, currentGridViewId, customFilterView);
  const switchActiveFilterView = useCallback(
    (filterViewId) => {
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
    [dispatch],
  );

  return (
    <FilterViewList
      activeFilterViewId={activeFilterView.filterViewId}
      CustomFilterViewContainer={OrdersCustomFilterViewContainer}
      DefaultFilterViewContainer={OrdersDefaultFilterViewContainer}
      FilterViewContainer={OrdersFilterViewContainer}
      filterViews={filterViews}
      switchActiveFilterView={switchActiveFilterView}
    />
  );
};

export const OrdersFilterviewListContainer = React.memo(OrdersFilterviewListContainerInnerComponent);
